<template>
   <div class="page-template">
    <div class="page-title">{{title}}
    </div>
    <div class="page-edit">
      <form-template ref="formTemplate">
         
      </form-template>
    </div>
  </div>
</template>

<script>
import formTemplate from "@/components/template/formTemplate";
import api from "@/config/api";
export default {
    components:{formTemplate},
    data(){
        return {
         title: '',
        dialogVisibility: false,
        addColumns: {
          formType: 'add',
          labelWidth: "200px",
          span: 12,
          columns: [
            {
              label: "每页显示数据条数",
              prop: "updateGoods",
              type: "select",
              url:api.system.seStore,
              rule: [{required: true}],
            },
            {
              label: "畅销商品设置(在X时间段内销量达到X则视为畅销商品，销量为0表示不限制销量)",
              type: "title",
              span:24
            },
            {
              label: "销售时间",
              type: "select",
              prop: "IntoLibrary",
              rule: [{required: true}],
            },
            {
              label: "最小销量",
              type: "inputNumber",
              prop: "scanCode",
              defaultValue:'0',
              rule: [{required: true}],
            },
            {
              label: "滞销商品设置(在X时间段内销量低于X且库存大于X视为滞销商品)",
              type: "title",
              span:24
            },
            {
              label: "销售时间",
              type: "select",
              prop: "updateSupplier",
              url:api.system.seStore,
              rule: [{required: true}],
            },
            {
              label: "销量低于",
              type: "inputNumber",
              prop: "quoteOnce",
              defaultValue:0,
              rule: [{required: true}],
            },
             {
              label: "库存大于",
              type: "inputNumber",
              prop: "quoteOnce",
              defaultValue:0,
              rule: [{required: true}],
              isAllline:true
            },
            {
              label: "禁止出库单据负库存出库",
              labelWidth:"300px",
              type: "switch",
              prop: "quoteMust",
              isAllline:true

            },
             {
              label: "按照当前库存判断（默认按照出库后库存）",
              labelWidth:"300px",
              type: "switch",
              prop: "quoeust",
              isAllline:true
            },
          ],
        }
        }
    },
    mounted(){
        this.title=document.title,
        this.$refs['formTemplate'] && this.$refs['formTemplate'].initData(this.addColumns);
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/page/system/maintain/Setting.vue